@switch ($displayType()) {
  @case ('tiles') {
    <div class="segment-tiles" role="tablist" [class.is-loading]="$showLoading()">
      @for (tile of store.$segmentFilters(); track tile._id) {
        @let active = tile._id === store.$segmentId();
        <button type="button" class="segment-tile" role="tab" [class.active]="active" [attr.aria-selected]="active" [attr.title]="countTooltip(tile._id)" (click)="onSelect(tile._id)">
          <span class="segment-tile-label">
            @if (tile.color) {
              <span class="segment-tile-dot" [style.background]="tile.color"></span>
            }
            <span class="text">{{ tile.label }}</span>
          </span>
          @if (store.$segmentCountsEnabled()) {
            <span class="segment-tile-count" [class.is-ready]="store.$segmentCountsReady()" [class.is-refetching]="$showLoading() && store.$segmentCountsReady()">
              @if (store.$segmentCountsReady()) {
                {{ store.$segmentCounts()[tile._id] ?? 0 | number }}
              } @else {
                &ndash;
              }
            </span>
          }
        </button>
      }
      @if ($showLoading()) {
        <span class="segment-tiles-progress" aria-hidden="true"></span>
      }
    </div>
  }
  @case ('pills') {
    <!-- Progress bar lives on the wrapper, NOT the scroller, so it stays pinned to the visible
         row instead of scrolling out of view with the pills. -->
    <div class="segment-pills-row" [class.is-loading]="$showLoading()">
      <div class="segment-pills" role="tablist">
        @for (pill of store.$segmentFilters(); track pill._id) {
          @let active = pill._id === store.$segmentId();
          <button type="button" class="segment-pill" role="tab" [class.active]="active" [attr.aria-selected]="active" [attr.title]="countTooltip(pill._id)" (click)="onSelect(pill._id)">
            @if (pill.color) {
              <span class="segment-pill-dot" [style.background]="pill.color"></span>
            }
            <span class="text">{{ pill.label }}</span>
            @if (store.$segmentCountsEnabled()) {
              @let count = store.$segmentCounts()[pill._id] ?? 0;
              <span class="segment-pill-count" [class.is-ready]="store.$segmentCountsReady()" [class.is-zero]="store.$segmentCountsReady() && !count" [class.is-refetching]="$showLoading() && store.$segmentCountsReady()">
                @if (store.$segmentCountsReady()) {
                  {{ count | number }}
                } @else {
                  &ndash;
                }
              </span>
            }
          </button>
        }
      </div>
      @if ($showLoading()) {
        <span class="segment-pills-progress" aria-hidden="true"></span>
      }
    </div>
  }
}
